
<nav class="navbar navbar-expand-md navbar-dark navbar-white fixed-top ml-auto">
  <div class="row">
    <div class="col-7 col-sm-7 menu outline-0 cp" (click)="onRefreshClick()" routerLink="/dashboard"><img class="tablogo mobdispblock" src="./assets/images/tl-215.png"  /></div>
    <div class="menu outline-0 cp tabhide" (click)="onClickLogo();"><img class="tablogo" src="./assets/images/tl-215.png"  /></div>

  <div class="col-5 col-sm-5 mobdispblock">
    <div class="row  ml-auto">
      <div class="col-4 col-sm-4">
        <!-- <button class="counter mt-1" *ngIf="count1==true">99+</button> -->
        <button class="counter mt-1 ml-3">{{count}}</button>
      </div>
       <div class="col-3 col-sm-3 border-pos">
        <img class="img-fluid mt-1 cp ml-2" (click)="notificationShow()" src="./assets/images/notification.png">
        <!-- <span class="orange">({{count}})</span> -->
        <div *ngIf="noti" class="notification text-left ">
          <div class="row">
            <div class="col-lg-5">
              <label class="fs-16 semi-bold black pad20 mb-0">Notification</label>
            </div>
            <div class="col-lg-7">
              <label class="fs-12 regular dblue notifyPad mb-0 cp" (click)="OnReadAll()">Mark All as Read</label>
      
            </div>
          </div>
          <!-- <label class="fs-16 semi-bold black pad20 mb-0 ">Notification</label> -->
          <div class="" *ngFor="let item of filterHistory | paginate: { itemsPerPage: 20, currentPage: p, totalItems: total}; let i=index">
            <label class="fs-16 semi-bold fent-grey pad20">{{item.date}}</label>
            <div class="today" *ngFor="let data of item.leads; let j =index">
            <label class="fs-14 regular" [ngClass]="filterHistory[i].leads[j].isRead?'':'rowbgcolor'" [innerHTML]="data.mesage"></label>
            <div class="text-right">
              <label class="fs-14 regular dblue cp text-right" *ngIf="filterHistory[i].leads[j].isRead==false" (click)="OnRead(data.id)">Mark as read</label>
            </div> 
            </div>
            <!-- <div class="today">
            <label class="fs-14 regular">Your <b>Licence 2</b> document has been approved for the following reason "Lorem Ipsum dummy reason"</label>
            </div> -->
            </div>
            <pagination-controls (click)="pageChnageDone(p)" (pageChange)="p = $event" class="float-right"></pagination-controls>
          <!-- <div class="">
            <label class="fs-16 semi-bold fent-grey pad20">YESTERDAY</label>
            <div class="today">
              <label class="fs-14 regular">Your <b>E&O</b> document has been approved</label>
            </div>
            <div class="today">
              <label class="fs-14 regular">Your <b>Licence 2</b> document has been approved for the following reason "Lorem Ipsum dummy reason"</label>
            </div>
          </div> -->
  
        </div>
      </div> 
      <div class="col-4 col-sm-4 ml-1">
        <span (click)="toggleShowone()" class="dropdown-toggle cp" data-toggle="dropdown"><img class="img-fluid mt-1 cp" src="./assets/images/user.png">
        <span class="fs-16 txt-lightblack regular"></span></span>
        <div *ngIf="drop" class="labelbox text-right" (click)="toggleShowone()">
          <img class="mr-4 float-left" src="./assets/images/setting.png">
          <span class="fs-14 semi-bold cp m-0 outline-0" (click)="toggleShowone()" routerLink="/account-info"> Account</span>
        <div class="clear5"></div>
        <img class="float-left mr-2 ml-1" src="./assets/images/contactUs.svg">
        <span class="fs-14 semi-bold cp m-0 outline-0" routerLink="/dashboard/contactus">Contact Us</span>
        <div class="clear5"></div>
        <img class="float-left mr-4 ml-1" src="./assets/images/signout.png">
        <span class="fs-14 semi-bold cp m-0 red outline-0" (click)="toggleShowone();logout()"  routerLink="/login">Sign-Out</span>
        </div>
      </div>

      </div>
  </div>
  </div>
  <button class="mobhide navbar-toggler olnone" type="button" data-toggle="collapse" data-target="#collapsibleNavbar" (click)="toggleNavbar()">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="collapsibleNavbar" [ngClass]="{ 'show': navbarOpen }">
    <!-- <div class="row"> -->
      <!-- <div class="col-lg-3"> -->
        <label class="fs-20 semi-bold txt-lightblack1 tabfs-18 mobhide" *ngIf="router.url === '/dashboard/personal-info' || router.url == '/dashboard'">Personal Info</label>
        <label class="fs-20 semi-bold txt-lightblack1 tabfs-18 mobhide" *ngIf="router.url === '/dashboard/upload-documents'">Upload Documents</label>
        <label class="fs-20 semi-bold txt-lightblack1 tabfs-18 mobhide" *ngIf="router.url === '/dashboard/contract-sign'">Sign Agreement </label>
        <label class="fs-20 semi-bold txt-lightblack1 tabfs-18 mobhide" *ngIf="router.url === '/dashboard/online-training'">Online Training</label>
      <!-- </div> -->
      <!-- <div class="col-lg-9">
        <label class="fs-14 italic red5">Please note, due to year-end closing, partnership requests received between December 16, 2022, and January 9, 2023, will be processed starting January 10, 2022, in the order they were received.</label>
      </div> -->
    <!-- </div> -->
    
    <ul class="navbar-nav ml-auto">
      <li class="mr-4">
        <!-- <button class="counter mt-1" *ngIf="count1==true">99+</button> -->
        <button class="counter mt-1">{{count}}</button>
      </li>
       <li class="nav-item border-right border-pos">
        <img class="img-fluid mt-1 cp mr-4" (click)="notificationShow()" src="./assets/images/notification.png">
        <!-- <span class="orange">({{count}})</span> -->
        <div *ngIf="noti" class="notification text-left ">
          <div class="row">
            <div class="col-lg-5">
              <label class="fs-16 semi-bold black pad20 mb-0">Notification</label>
            </div>
            <div class="col-lg-7">
              <label class="fs-12 regular dblue notifyPad mb-0 cp" (click)="OnReadAll()">Mark All as Read</label>
      
            </div>
          </div>
          <!-- <label class="fs-16 semi-bold black pad20 mb-0 ">Notification</label> -->
          <div class="" *ngFor="let item of filterHistory | paginate: { itemsPerPage: 20, currentPage: p, totalItems: total}; let i=index">
            <label class="fs-16 semi-bold fent-grey pad20">{{item.date}}</label>
            <div class="today" *ngFor="let data of item.leads; let j =index">
            <label class="fs-14 regular cp" [ngClass]="filterHistory[i].leads[j].isRead?'':'rowbgcolor'" (click)="onClickMessage(data.mesage)" [innerHTML]="data.mesage"></label>
            <div class="text-right">
              <label class="fs-14 regular dblue cp text-right" *ngIf="filterHistory[i].leads[j].isRead==false" (click)="OnRead(data.id)">Mark as read</label>
            </div> 
            </div>
            <!-- <div class="today">
            <label class="fs-14 regular">Your <b>Licence 2</b> document has been approved for the following reason "Lorem Ipsum dummy reason"</label>
            </div> -->
            </div>
            <pagination-controls (click)="pageChnageDone(p)" (pageChange)="p = $event" class="float-right"></pagination-controls>
          <!-- <div class="">
            <label class="fs-16 semi-bold fent-grey pad20">YESTERDAY</label>
            <div class="today">
              <label class="fs-14 regular">Your <b>E&O</b> document has been approved</label>
            </div>
            <div class="today">
              <label class="fs-14 regular">Your <b>Licence 2</b> document has been approved for the following reason "Lorem Ipsum dummy reason"</label>
            </div>
          </div> -->
  
        </div>
      </li> 
      <li class="nav-item">
        <span (click)="toggleShowone()" class="dropdown-toggle cp" data-toggle="dropdown"><img class="img-fluid mt-1 cp mr-3" src="./assets/images/user.png">
        <span class="fs-16 txt-lightblack regular">{{name}}</span><br>
        <span class="fs-16 txt-lightblack regular mlLeft">{{showAgencyCode}}</span></span>
        <div *ngIf="drop" class="labelbox text-right" (click)="toggleShowone()">
          <img class="mr-4 float-left" src="./assets/images/setting.png">
          <span class="fs-14 semi-bold cp m-0 outline-0" (click)="toggleShowone()" routerLink="/account-info"> Account</span>
        <div class="clear5"></div>
        <img class="float-left mr-2 ml-1" src="./assets/images/contactUs.svg">
        <span class="fs-14 semi-bold cp m-0 outline-0" routerLink="/dashboard/contactus">Contact Us</span>
        <div class="clear5"></div>
        <img class="float-left mr-4 ml-1" src="./assets/images/signout.png">
        <span class="fs-14 semi-bold cp m-0 red outline-0" (click)="toggleShowone();logout()"  routerLink="/login">Sign-Out</span>
        </div>
        </li>

    </ul>
  </div>
 
</nav>


